<script lang="ts" setup>
  import { toRef, toRefs } from 'vue';
  import { useField } from 'vee-validate';
  import TextArea, { type TextAreaProps } from './TextArea.vue';

  export type TextAreaFieldProps = TextAreaProps & {
    rules?: (value: string) => string | boolean;
  };

  const props = withDefaults(defineProps<TextAreaFieldProps>(), {
    value: undefined,
    rules: undefined,
    type: 'text',
  });

  const {
    name: inputName,
    label,
    rules,
    ...rest
  } = toRefs<TextAreaFieldProps>(props);

  const inputProps = toRef(rest);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<string>(inputName.value, rules?.value, {
    label: label?.value,
  });

  const onBlur = () => {
    handleBlur(undefined, true);
  };
</script>

<template>
  <TextArea
    v-bind="inputProps"
    :id="id"
    :error="errorMessage as string"
    :label="label"
    :loading="loading"
    :max-length="maxLength"
    :meta="meta"
    :model-value="inputValue as string"
    :name="name"
    :placeholder="placeholder"
    :rows="rows"
    :wrap="wrap"
    :min-height="minHeight"
    @blur="onBlur"
    @update:modelValue="handleChange"
  ></TextArea>
</template>
